import React from 'react';
import InstagramEmbed from './InstagramEmbed';
import { useState, useEffect } from 'react';

const InstagramPostList = () => {
    const originalPosts = [
        'https://www.instagram.com/p/DD7QoI0OpGt/', 
        // 'https://www.instagram.com/p/DDnevNIyQ0y/',
        // 'https://www.instagram.com/p/DChjQSky8ZG/',
        // 'https://www.instagram.com/p/DCNOSxXSzdo/',
        // 'https://www.instagram.com/p/DB9azXaSqdY/',
        // 'https://www.instagram.com/p/DBpdUbFR-YT/',
        // 'https://www.instagram.com/p/DBNP0WfxCL1/',
        // 'https://www.instagram.com/p/DA4oFEAxBQr/',
        // 'https://www.instagram.com/p/C_-8ttJx-Oa/',
        // 'https://www.instagram.com/p/C_qdI2cxPrU/',
        // 'https://www.instagram.com/p/C-3Q6hzRpOb/',
        // 'https://www.instagram.com/p/C-tkDm_xbfs/',
        // 'https://www.instagram.com/p/C-bpXlXxPT2/',
        // 'https://www.instagram.com/p/C-TDBPIxQGK/',
        // 'https://www.instagram.com/p/C-IqJATxtEd/',
        // 'https://www.instagram.com/p/C9ul3-yxBCv/',
        // 'https://www.instagram.com/p/C9cvk54RGba/',
        // 'https://www.instagram.com/p/C9LqRL-xgV9/',
        // 'https://www.instagram.com/p/C7z_vnFvmLi/',
        // 'https://www.instagram.com/p/C7h8zsxRIlf/',
        // 'https://www.instagram.com/p/C7QLe8StuOE/',
        // 'https://www.instagram.com/p/C693CJVxAJr/',
        // 'https://www.instagram.com/p/C52BKr3rk-l/',
        // 'https://www.instagram.com/p/C5t_xUrvDbX/',
        // 'https://www.instagram.com/p/C5PTj-WRg5D/',
        // 'https://www.instagram.com/p/C5CXMgURVQY/',
        // 'https://www.instagram.com/p/C44BBbcxwxV/',
        // 'https://www.instagram.com/p/C4a-nhGLvc0/',
        // 'https://www.instagram.com/p/C4WqXJxRez_/',
        // 'https://www.instagram.com/p/C4Gva61vf6g/',
        // 'https://www.instagram.com/p/C3vcCvYtfIS/',
        // 'https://www.instagram.com/p/C3jXVCbtCNw/',
        // 'https://www.instagram.com/p/C3OJsLXPggQ/',
        // 'https://www.instagram.com/p/C3I6TjfvQbF/',
        // 'https://www.instagram.com/p/C2kYATOLDKH/',
        // 'https://www.instagram.com/p/C2S3b7gPbg1/',
        // 'https://www.instagram.com/p/C2Igb3FxhpB/',
        // 'https://www.instagram.com/p/C13JVzsN0oh/',
        // 'https://www.instagram.com/p/C1qVaNyt2X7/',
        // 'https://www.instagram.com/p/C0_36UtLcwM/',
        // 'https://www.instagram.com/p/C04i5OaxMjL/',
        // 'https://www.instagram.com/p/C0r9bmEvqnY/',
        // 'https://www.instagram.com/p/C0Sh6Faxw-p/',
        // 'https://www.instagram.com/p/C0KAauSL5k3/',
        // 'https://www.instagram.com/p/Cz9itOTvxzY/',
        // 'https://www.instagram.com/p/Cz675iuPw5w/',
        // 'https://www.instagram.com/p/CzXeR68rx-a/',
        // 'https://www.instagram.com/p/CzCrp5VRl7T/',
        // 'https://www.instagram.com/p/Cy1zrIqx6oZ/',
        // 'https://www.instagram.com/p/Cyt5PxmPkjx/',
        // 'https://www.instagram.com/p/CyoO_lqgKZ0/',
        // 'https://www.instagram.com/p/CyjnSQ8PDHS/',
        // 'https://www.instagram.com/p/Cyb0ygJvqY3/',
        // 'https://www.instagram.com/p/Cx3QuIyAgC2/',
        // 'https://www.instagram.com/p/Cxv1ZC7PJTI/',
        // 'https://www.instagram.com/p/Cxl17mCvII5/',
        // 'https://www.instagram.com/p/Cxa48fsRkfO/',
        // 'https://www.instagram.com/p/CxTbJCtv_v9/',
        // 'https://www.instagram.com/p/CxI_NPdrFAK/',
        // 'https://www.instagram.com/p/CxHSMGht71e/',
        // 'https://www.instagram.com/p/CxGI7DZLg2r/',
        // 'https://www.instagram.com/p/CxCCuXKLpJn/',
        // 'https://www.instagram.com/p/CwngEver6s0/',
        // 'https://www.instagram.com/p/CwQ0-jvrvUI/',
        // 'https://www.instagram.com/p/CwOsFcztghF/',
        // 'https://www.instagram.com/p/CwN4Q1uLcXg/',
        // 'https://www.instagram.com/p/CwGKJmkO9rM/',
        // 'https://www.instagram.com/p/CwAQrhguy26/',
        // 'https://www.instagram.com/p/CwAPlAXOOYJ/',
        // 'https://www.instagram.com/p/Cv-0TOFulPn/',
    ];

    const shuffleArray = (array) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    const [posts, setPosts] = useState([]);

    useEffect(() => {
        setPosts(shuffleArray(originalPosts));
    }, []);


    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
            {posts.map((post, index) => (
                <InstagramEmbed key={index} url={post} />
            ))}
        </div>
    );
};

export default InstagramPostList;